<template>
  <div>
    <h1>欢迎您{{ username }}进入后台管理系统</h1>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        collapse: false,
        fullscreen: false,
        name: "admin",
        message: 2
      };
    },
    computed: {
      username() {
        let username = localStorage.getItem("username");
        return username ? username : this.name;
      }
    }
  }
</script>


<style scoped>

</style>
